import getServerSidePropsPage from 'root/src/client/util/getServerSidePropsPage';
import { RedesignDropsPage } from 'root/src/client/v2/_pages/drops/redesign/RedesignDropsPage';
export const getServerSideProps = getServerSidePropsPage;
export default RedesignDropsPage;
